import { render } from "./AppButton.vue?vue&type=template&id=40f065d6"
const script = {}

import exportComponent from "/home/runner/work/adaptif-frontend/adaptif-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__